import { all, call, put, take, takeEvery, takeLatest } from 'redux-saga/effects'
import { cloneDeep } from '../modules/utilities'
import * as api from '../services/api'
import HOOK from "../components/hooks"
import { CHECKBOX } from '../modules/checkbox_constants'
import { LSE_INDEX_ENUM, POSITION_TYPE, TENSE_ENUM } from "../modules/constants"
import history from "../services/history"
import { map } from "../components/layout/SearchMapping"
import { appendCheckboxesToUrl } from "../modules/commonModule"

const initialState = {
  apptsMeta: {},
  companiesMeta: {},
  peopleMeta: {},
  eventsMeta: {},
}

export function reducer(state = initialState, action) {

  switch (action.type) {

    case 'lse.setCompaniesMeta': {
      // console.log('lse.setCompaniesMeta action:', action)
      return {
        ...state,
        companiesMeta: action.companiesMeta,
      }
    }

    case 'lse.setApptsMeta': {
      // console.log('lse.setApptsMeta action:', action)
      return {
        ...state,
        apptsMeta: action.apptsMeta,
      }
    }

    case 'lse.setPeopleMeta': {
      // console.log('lse.setPeopleMeta action:', action)
      return {
        ...state,
        peopleMeta: action.peopleMeta,
      }
    }

    case 'lse.setEventsMeta': {
      // console.log('lse.setEventsMeta action:', action)
      return {
        ...state,
        eventsMeta: action.eventsMeta,
      }
    }

    default: {
      return state
    }
  }
}

function* handleGetCompaniesMeta() {
  const companiesMeta = yield call(api.lse.getLseCompanies)
  yield put(actions.setCompaniesMeta(companiesMeta))
  yield put({ type: 'synopsis.get' })
}

function* watchGetPerson() {
  while (true) {
    const props = yield take('lse.getPerson')
    // console.log('lse.getPerson props: ', props)
    const { checkboxes, companyName, nexusView, personName } = props
    const url = yield call(api.lse.getPerson, companyName, personName)

    // handle 350 csearch and psearch (company only)
    url.pathname = personName
      ? `person/${url.myString}`
      : `company/${url.myString}`

    url.search = `?view=${nexusView}`

    if (personName) // Defaults plus Past, Future and Secretary
    {
      checkboxes[HOOK.TENSE] = checkboxes[HOOK.TENSE] | CHECKBOX[HOOK.TENSE][TENSE_ENUM.PAST].BIT
      checkboxes[HOOK.TENSE] = checkboxes[HOOK.TENSE] | CHECKBOX[HOOK.TENSE][TENSE_ENUM.FUTURE].BIT
      checkboxes[HOOK.POSITION] = checkboxes[HOOK.POSITION] | CHECKBOX[HOOK.POSITION][POSITION_TYPE.SECRETARY].BIT
    } else  // Defaults plus AIM All-Share
      checkboxes[HOOK.LSE_INDEX] = checkboxes[HOOK.LSE_INDEX] | CHECKBOX[HOOK.LSE_INDEX][LSE_INDEX_ENUM.AIM_All_Share].BIT

    appendCheckboxesToUrl({ checkboxes, url })

    history.push(`/${url.pathname}/${url.search}`)
  }
}

function* handleGetApptsMeta() {
  const apptsMeta = yield call(api.lse.getLseApptsMeta)
  MapApptsMeta(apptsMeta)
  yield put(actions.setApptsMeta(apptsMeta))
}

const MapApptsMeta = apptsMeta => {
  for (let index = 0; index < apptsMeta.items.length; index++) {
    apptsMeta.items[index] = map.apptItemProps(apptsMeta.items[index])
  }
}

function* handleGetPeopleMeta() {
  const peopleMeta = yield call(api.lse.getLsePeopleMeta)
  MapPeopleMeta(peopleMeta)
  yield put(actions.setPeopleMeta(peopleMeta))
}

function* handleGetEventsMeta() {
  const eventsMeta = yield call(api.lse.getLseEventsMeta)
  yield put(actions.setEventsMeta(eventsMeta))
}

const MapPeopleMeta = peopleMeta => {
  for (let index = 0; index < peopleMeta.items.length; index++) {
    peopleMeta.items[index] = map.personItemProps(peopleMeta.items[index])
  }
}


const createSyncFavouriteWatcher = (actionType, metaPropKey, parseFn, setAction) => {
  function* handler(props) {
    let metaClone = cloneDeep(props[metaPropKey])
    parseFn(metaClone, props.favourites)
    metaClone.synced = true
    yield put(setAction(metaClone))
  }
  return takeEvery(actionType, handler)
}

const createSetByIndexWatcher = (actionType, metaPropKey, setAction) => {
  function* handler({ index, isFavourite, ...props }) {
    let metaClone = cloneDeep(props[metaPropKey])
    if (index !== undefined)
      metaClone.items[index].isFavourite = isFavourite
    yield put(setAction(metaClone))
  }
  return takeEvery(actionType, handler)
}

const parseFavourites = (companiesMetaClone, favourites) => {
  favourites.companies.forEach(company => {
    const index = companiesMetaClone.items.map(e => e.ids[0]).indexOf(company._id)
    if (index !== -1)
      companiesMetaClone.items[index].isFavourite = true
  })
}


const parsePeopleFavourites = (peopleMetaClone, favourites) => {
  favourites.people.forEach(person => {
    for (let i = 0; i < peopleMetaClone.items.length; i++)
      if (peopleMetaClone.items[i].commonInfo.officerIds.indexOf(person._id) > 0)
        peopleMetaClone.items[i].isFavourite = true
  })
}

function* handleSetIsFavouriteById({ _id, isFavourite, lseCompaniesMeta }) {
  if (lseCompaniesMeta) {
    let companiesMetaClone = cloneDeep(lseCompaniesMeta)
    const index = companiesMetaClone.items.map(e => e.ids[0]).indexOf(_id)
    if (index !== -1) {
      companiesMetaClone.items[index].isFavourite = isFavourite
      yield put(actions.setCompaniesMeta(companiesMetaClone))
    }
  }
}

function* handleSetIsFavouritePersonById({ _id, isFavourite, lsePeopleMeta }) {
  if (lsePeopleMeta) {
    let peopleMetaClone = cloneDeep(lsePeopleMeta)
    let index = peopleMetaClone.items.map(e => e.commonInfo.officerIds[1]).indexOf(_id)
    if (index === -1)
      index = peopleMetaClone.items.map(e => e.commonInfo.officerIds[0]).indexOf(_id)

    if (index !== -1) {
      peopleMetaClone.items[index].isFavourite = isFavourite
      yield put(actions.setPeopleMeta(peopleMetaClone))
    }
  }
}

export const actions = {
  getCompaniesMeta: () => ({ type: 'lse.getCompaniesMeta' }),
  setCompaniesMeta: companiesMeta => ({ companiesMeta, type: 'lse.setCompaniesMeta' }),

  getApptsMeta: props => ({ ...props, type: 'lse.getApptsMeta' }),
  setApptsMeta: apptsMeta => ({ apptsMeta, type: 'lse.setApptsMeta' }),

  getPeopleMeta: props => ({ ...props, type: 'lse.getPeopleMeta' }),
  setPeopleMeta: peopleMeta => ({ peopleMeta, type: 'lse.setPeopleMeta' }),

  getEventsMeta: props => ({ ...props, type: 'lse.getEventsMeta' }),
  setEventsMeta: eventsMeta => ({ eventsMeta, type: 'lse.setEventsMeta' }),

  getPerson: props => ({ ...props, type: 'lse.getPerson' }),
  setIsFavouriteByIndex: (companiesMeta, index, isFavourite) =>
    ({ type: 'lse.setIsFavouriteByIndex', companiesMeta, index, isFavourite }),
  setIsFavouritePersonByIndex: (peopleMeta, index, isFavourite) =>
    ({ type: 'lse.setIsFavouritePersonByIndex', peopleMeta, index, isFavourite }),
  updateIsFavourite: props => ({ ...props, type: 'lse.updateIsFavourite' }),
  updateIsPersonFavourite: props => ({ ...props, type: 'lse.updatePersonIsFavourite' }),
  setIsFavouriteById: props => ({ ...props, type: 'lse.setIsFavouriteById' }),
  setIsFavouritePersonById: props => ({ ...props, type: 'lse.setIsFavouritePersonById' }),
}

export const selectors = {
}

const watchUpdateIsFavourite = createSyncFavouriteWatcher(
  'lse.updateIsFavourite', 'lseCompaniesMeta', parseFavourites, actions.setCompaniesMeta
)

const watchUpdatePersonIsFavourite = createSyncFavouriteWatcher(
  'lse.updatePersonIsFavourite', 'lsePeopleMeta', parsePeopleFavourites, actions.setPeopleMeta
)

const watchSetIsFavouriteCompanyByIndex = createSetByIndexWatcher(
  'lse.setIsFavouriteByIndex', 'companiesMeta', actions.setCompaniesMeta
)
const watchSetIsFavouritePersonByIndex = createSetByIndexWatcher(
  'lse.setIsFavouritePersonByIndex', 'peopleMeta', actions.setPeopleMeta
)

export function* sagas() {
  yield all([
    takeLatest('lse.getCompaniesMeta', handleGetCompaniesMeta),
    takeLatest('lse.getApptsMeta', handleGetApptsMeta),
    takeLatest('lse.getPeopleMeta', handleGetPeopleMeta),
    takeLatest('lse.getEventsMeta', handleGetEventsMeta),
    watchGetPerson(),
    watchSetIsFavouriteCompanyByIndex,
    watchSetIsFavouritePersonByIndex,
    watchUpdateIsFavourite,
    watchUpdatePersonIsFavourite,
    takeEvery('lse.setIsFavouriteById', handleSetIsFavouriteById),
    takeEvery('lse.setIsFavouritePersonById', handleSetIsFavouritePersonById),
  ])
}

